<form
  class="resgate-filtro"
  aria-label="Buscar instituto"
  data-testid="instituto-filtro"
  (submit)="$event.preventDefault()"
>
  <vivest-autocomplete
    #campoInstituto
    class="resgate-filtro__instituto"
    error-message=""
    icon="search"
    label="Procure por instituto"
    name="instituto"
    status="default"
    [placeholder]="placeholder()"
    [options]="opcoes()"
    [disabled]="carregando()"
    (vivest-select)="aoSelecionar($event)"
    data-testid="instituto-busca"
  ></vivest-autocomplete>

  <div class="resgate-filtro__acoes">
    <vivest-button variant="outline" size="md" data-testid="instituto-limpar" (click)="limpar()">
      Limpar
    </vivest-button>
  </div>
</form>
